import { RefObject, useCallback } from 'react';

/** Focuses the input when the select is not in the active (locked) state. */
const useHandleFocusInputOnClick = ({
  lockActiveState,
  inputRef,
  onFocus,
}: {
  lockActiveState: boolean;
  inputRef?: RefObject<HTMLInputElement | null>;
  onFocus: () => void;
}) => {
  return useCallback(() => {
    if (lockActiveState) return;
    const input = inputRef?.current;
    // the input can keep DOM focus while the select is inactive (e.g. a modal's focus lock returned focus to it),
    // and focus() on an already-focused element fires no focus event - activate it directly instead
    if (input && document.activeElement === input) {
      onFocus();
      return;
    }
    input?.focus();
  }, [lockActiveState, inputRef, onFocus]);
};

export default useHandleFocusInputOnClick;
